import api from '@/apis'
import * as TYPES from './mutationTypes'

export default {
  getSpvLightNodesLists({ commit }, params) {
    return api.spvlightnodes
      .getList(params)
      .then(response => response.data)
      .then(result => {
        commit(TYPES.GET_SPV_LIGHT_NODES, {
          result,
          params
        })
        return result
      })
      .catch(error => Promise.reject(error))
  }
}
